import { render, staticRenderFns } from "./SourceChooser.vue?vue&type=template&id=74a19236&scoped=true&"
import script from "./SourceChooser.vue?vue&type=script&lang=js&"
export * from "./SourceChooser.vue?vue&type=script&lang=js&"
import style0 from "./SourceChooser.vue?vue&type=style&index=0&id=74a19236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a19236",
  null
  
)

export default component.exports